import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Subscribe from './pages/Subscribe.jsx';

import Home from './pages/Home.jsx';
import Services from './pages/Services.jsx';
import About from './pages/About.jsx';
import Trust from './pages/Trust.jsx';
import Faq from './pages/Faq.jsx';
import Blog from './pages/Blog.jsx';
import Post from './pages/Post.jsx';
import Newsletter from './pages/Newsletter.jsx';
import Checker from './pages/Checker.jsx';
import Contact from './pages/Contact.jsx';
import { Privacy, Terms } from './pages/Legal.jsx';
import NotFound from './pages/NotFound.jsx';

export default function App() {
  const { pathname } = useLocation();

  // The signup belongs at the foot of most pages, but not on the two where it
  // would be noise: the contact form is already a form, and the legal pages
  // are not a place to sell anything.
  const showSubscribe = !/^\/(contact|privacy|terms)/.test(pathname);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Post />} />
        <Route path="/newsletter/:slug" element={<Newsletter />} />
        <Route path="/checker" element={<Checker />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {showSubscribe && (
        <section className="section subscribe-section">
          <div className="shell"><Subscribe /></div>
        </section>
      )}
    </Layout>
  );
}
